class s{constructor(){this._call=null,this._unsubscribed=!1}_setCall(s){this._call=s}unsubscribe(){null!=this._call&&(this._unsubscribed=!0,this._call())}}export{s as default};
//# sourceMappingURL=SubscriptionHandle.js.map
